module.exports = __webpack_public_path__ + "media/images/icon_edit1_24-24-db5e7117c4a5825752be5d975761c2fb.png";